function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57491",
    d: "M99.5 0A3.51 3.51 0 0 0 96 3.5v49a3.51 3.51 0 0 0 3.5 3.5h35a3.51 3.51 0 0 0 3.5-3.5V14L124 0z",
    transform: "translate(-89)",
    style: {
      fill: "#e2e5e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57492",
    d: "M355.5 14H366L352 0v10.5a3.51 3.51 0 0 0 3.5 3.5z",
    transform: "translate(-317)",
    style: {
      fill: "#b0b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57493",
    d: "M394.5 138.5 384 128h10.5z",
    transform: "translate(-345.5 -114)",
    style: {
      fill: "#cad1d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57494",
    d: "M74 259.25a1.755 1.755 0 0 1-1.75 1.75h-38.5a1.755 1.755 0 0 1-1.75-1.75v-17.5a1.755 1.755 0 0 1 1.75-1.75h38.5a1.755 1.755 0 0 1 1.75 1.75z",
    transform: "translate(-32 -213.75)",
    style: {
      fill: "#f15642"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17215"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57495",
    d: "M101.744 295.286a.963.963 0 0 1 .95-.966h3.232a3.5 3.5 0 0 1 0 7h-2.336v1.848a.878.878 0 0 1-.9.964.943.943 0 0 1-.95-.964zm1.846.8v3.486h2.336a1.744 1.744 0 0 0 0-3.486z",
    transform: "translate(-94.116 -262.129)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57496",
    d: "M188.79 305.155a.876.876 0 0 1-.966-.866v-7.949a.952.952 0 0 1 .966-.868h3.2c6.394 0 6.254 9.683.126 9.683zm.882-7.975v6.268h2.322c3.778 0 3.946-6.268 0-6.268z",
    transform: "translate(-170.781 -263.155)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57497",
    d: "M288.967 297.278v2.222h3.568a1.082 1.082 0 0 1 1.008.992.972.972 0 0 1-1.008.84h-3.568v2.938a.829.829 0 0 1-.838.866.889.889 0 0 1-.992-.866v-7.948a.884.884 0 0 1 .992-.868h4.912a.873.873 0 0 1 .98.868.967.967 0 0 1-.98.952h-4.074z",
    transform: "translate(-259.231 -263.141)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57498",
    d: "M129.25 417.75H96v1.75h33.25a1.755 1.755 0 0 0 1.75-1.75V416a1.755 1.755 0 0 1-1.75 1.75z",
    transform: "translate(-89 -370.5)",
    style: {
      fill: "#cad1d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.95a615e2435eb077a1ada2fe5814ece8.svg";
export { ForwardRef as ReactComponent };